import { useEffect, useState } from "react";
import { API } from "./api";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import Dashboard from "./Dashboard";

export default function LLMModels() {
  const [apps, setApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedEnv, setSelectedEnv] = useState(null);

  useEffect(() => {
    API.get("/apps").then(res => {
      const data = res.data.data || res.data || [];

      // ✅ FILTER ONLY LLM MODULES
      const llmApps = data.filter(a =>
        (a.module || "").toLowerCase().startsWith("llm")
      );

      setApps(llmApps);
    });
  }, []);

  // ✅ STEP 1 — APPLICATION CARDS
  if (!selectedApp) {
    const uniqueApps = [...new Set(apps.map(a => a.app_name))];

    return (
      <Grid container spacing={3}>
        {uniqueApps.map(app => (
          <Grid item xs={2} key={app}>
            <Card onClick={() => setSelectedApp(app)}
              style={{ cursor: "pointer", background: "#6366f1", color: "white" }}>
              <CardContent>
                <Typography>{app}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // ✅ STEP 2 — ENV CARDS
  if (!selectedEnv) {
    const envCounts = apps
  .filter(a => a.app_name === selectedApp)
  .reduce((acc, app) => {
    const env = (app.environment || "").trim();
    if (!env) return acc;

    acc[env] = (acc[env] || 0) + 1;
    return acc;
  }, {});

    return (
      <Grid container spacing={3}>
        {Object.entries(envCounts).map(([env, count]) => (
          <Grid item xs={2} key={env}>
            <Card onClick={() => setSelectedEnv(env)}
              style={{ cursor: "pointer", background: "#10b981", color: "white" }}>
              <CardContent>
                <Typography>{env} ({count})</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // ✅ STEP 3 — TABLE
  return (
    <Dashboard
      filterApp={selectedApp}
      filterEnv={selectedEnv}
      llmOnly={true}
    />
  );
}

